/**
 * Nova AI chat interface color definitions
 */
import { palette, createColor } from './palette.colors';

export const novaAIColors = {
  BGColor: createColor(palette.gray.white, palette.blue.softBlue),
  borderMainColor: createColor(palette.gray.white, palette.gray.lightDarkGrey),
  shadowColor: createColor(palette.special.shadowLight, palette.special.shadow),
  AIShadowColor: createColor(palette.special.shadow, palette.special.shadow),
  borderColor: createColor(palette.gray.border, palette.dark.borderLight),
  userMessageBGColor: createColor(palette.blue.primary, palette.blue.pressed),
  userMessageColor: createColor(palette.gray.white, palette.gray.white),
  userMessageBorder: createColor(palette.gray.borderMedium, palette.gray.borderMedium),
  userMessageText: createColor(palette.gray.white, palette.gray.white),
  botMessageBGColor: createColor(palette.gray.white, 'transparent'),
  botMessageColor: createColor(palette.gray.black, palette.gray.black),
  botMessageBorder: createColor(palette.gray.borderMedium, palette.blue.pressed),
  botMessageText: createColor(palette.gray.darkest, palette.gray.white),
  searchTextInputTopBorderColor: createColor(palette.gray.borderMedium, palette.gray.lightDarkGrey),
  inputTextColor: createColor(palette.gray.black, palette.gray.white),
  inputTextBorderColor: createColor(palette.gray.borderMedium, palette.dark.techBorder),
  footerTextColor: createColor(palette.gray.darker, palette.gray.darker),
  botIconBGColor: createColor(palette.blue.tint, palette.blue.tint),
  contextText: createColor(palette.blue.onTint, palette.gray.white),
  contextSubText: createColor(palette.gray.lightDarkGrey, palette.gray.white),
  iconBGColor: createColor(palette.blue.secondary, palette.blue.secondary),
  cardBorderColor: createColor(palette.gray.divider, palette.gray.lightDarkGrey),
  cardTextColor: createColor(palette.blue.onTint, palette.gray.white),
  cardExampleTextColor: createColor(palette.gray.lightDarkGrey, palette.gray.white),
  voiceIconGreyColor: createColor(palette.gray.darkest, palette.gray.white),
  voiceIconBlueColor: createColor(palette.gray.white, palette.gray.white),
  voiceIconGreyFillColor: createColor(palette.gray.bottomGreyBorder, 'transparent'),
  voiceIconBlueFillColor: createColor(palette.blue.primary, palette.blue.primary),
  waveformBarColor: createColor(palette.opacity.novaVoiceBase, palette.opacity.novaVoiceBase),
  volumeIconColor: createColor(palette.gray.darkest, palette.gray.white),
/** NovaAIChatWindowIcon — background fill.
   *  Light: #EAF2FB  |  Dark: #2B78CA (reversed) */
  chatWindowIconBGColor: createColor(palette.blue.chatWindowBG, palette.blue.primary),
  /** NovaAIChatWindowIcon — stroke / icon colour.
   *  Light: #2B78CA  |  Dark: #EAF2FB (reversed) */
  chatWindowIconColor: createColor(palette.blue.primary, palette.blue.chatWindowBG),
  /** NovaAIChatBotIcon — background fill.
   *  Light: palette.blue.tintBase (#81B7DE) — opacity applied via fillOpacity
   *  Dark:  palette.blue.pressed (#002859, solid) */
  chatBotIconBGColor: createColor(palette.blue.selectedItemBG, palette.blue.pressed),
  /** NovaAIChatBotIcon — stroke / icon colour.
   *  Light: palette.blue.primary (#2B78CA)
   *  Dark:  palette.blue.selectedBorder (#66ABFF) */
  chatBotIconColor: createColor(palette.blue.selectedText, palette.blue.selectedBorder),
};